import { render } from "./auth.vue?vue&type=template&id=4ff390bc&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"

import "./auth.vue?vue&type=style&index=0&id=4ff390bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff390bc"]])

export default __exports__